var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 438,
    viewBox: "0 0 333 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.429 0.199091L47.5714 0C21.4071 0 0 17.9182 0 39.8182V398.182C0 420.082 21.4071 438 47.5714 438H285.429C311.593 438 333 420.082 333 398.182V39.8182C333 17.9182 311.593 0.199091 285.429 0.199091ZM285.429 358.364H47.5714V79.6364H285.429V358.364Z",
    fill: "#323232"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneView);
export default __webpack_public_path__ + "static/media/phone-view.3acd64c5.svg";
export { ForwardRef as ReactComponent };